// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD9wkU267VkVZq1gnHqXXEzEiV2KGxIO_w",
  authDomain: "planopt-60e1e.firebaseapp.com",
  projectId: "planopt-60e1e",
  styorageBucket: "planopt-60e1e.firebasestorage.app",
  messagingSenderId: "808797426336",
  appId: "1:808797426336:web:6abc12d3d29c2964496fc5",
  measurementId: "G-4J3L7W2PJ3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, analytics, db };
